import React from "react";
import { Img } from "../../Img";
export const KeepTraderInOrderSwiperCard = ({ comments, imageUrl, imageAlt }) => (React.createElement("div", { className: "keepTraderInOrderSwiperCard" },
    React.createElement(Img, { src: imageUrl, alt: imageAlt, className: "keepTraderInOrderSwiperCard__image", loading: "eager" }),
    React.createElement("span", { className: "keepTraderInOrderSwiperCard__textWrapper" },
        React.createElement("h5", { className: "keepTraderInOrderSwiperCard__textWrapper__title", dangerouslySetInnerHTML: { __html: comments.title } }),
        React.createElement("p", { className: "keepTraderInOrderSwiperCard__textWrapper__description", dangerouslySetInnerHTML: {
                __html: comments.description
            } }))));
